<template>
  <qx-card title="列表">
    <ApproveDialog ref="approveDialog" @sub="getData" />
    <ContractDialog ref="contractDialog" @sub="getData" />
    <BillDialog ref="billDialog" @sub="getData" />
    <CarDetailDialog ref="carDetailDialog" />
    <LogRightDialog ref="logRightDialog" busiCode="300000" />
    <BatchApproveDialog ref="batchApproveDialog" @sub="getData" />
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <el-button type="primary" plain @click="batchApprove"
          >批量审核</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tableBox" ref="tableBox">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <!-- 订单号码 -->
                <section v-if="scope.column.property === 'orderId'">
                  <span v-if="scope.row.orderType === 1">固定：</span>
                  <span v-else-if="scope.row.orderType === 2">
                    <span v-if="scope.row.sourceFlag === 14">城配：</span>
                    <span v-else>临时：</span>
                  </span>
                  <span v-else>三方：</span>
                  <span class="primary cur" @click="toOrderDetail(scope.row)">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <!-- 订单号码 end -->
                <!-- 运输线路 -->
                <section
                  v-else-if="scope.column.property === 'sourceRegionName'"
                >
                  <span
                    :class="{
                      primary: scope.row.sourceId !== -1,
                      cur: scope.row.sourceId !== -1,
                    }"
                    @click="toLineDetail(scope.row)"
                    >{{
                      `${scope.row.sourceRegionName.replace(
                        '市',
                        ''
                      )}-${scope.row.desRegionName.replace('市', '')}`
                    }}</span
                  >
                </section>
                <!-- 运输线路 end -->
                <!-- 订单收入 -->
                <section v-else-if="scope.column.property === 'costPrice'">
                  {{ scope.row[scope.column.property] / 100 }}
                </section>
                <!-- 订单收入 end -->
                <!-- 车牌号码 -->
                <section v-else-if="scope.column.property === 'plateNumber'">
                  <el-popover placement="top" width="120" trigger="hover">
                    <div style="text-align: left">
                      <p>司机：{{ scope.row.carDriverMan }}</p>
                      <p>手机：{{ scope.row.carDriverPhone }}</p>
                      <p>车型：{{ scope.row.vehicleClassName }}</p>
                    </div>
                    <span class="primary cur" slot="reference">{{
                      scope.row[scope.column.property]
                    }}</span>
                  </el-popover>
                </section>
                <!-- 车牌号码 end -->
                <!-- 车辆类型 -->
                <section v-else-if="scope.column.property === 'licenceType'">
                  <span v-if="scope.row.licenceType === 2">{{
                    scope.row[scope.column.property]
                  }}</span>
                  <span v-else
                    >{{ scope.row.carLenghName }} /
                    {{ scope.row.carStatusName }}</span
                  >
                </section>
                <!-- 车辆类型 end -->
                <!-- 运费 -->
                <section v-else-if="scope.column.property === 'totalFee'">
                  {{ scope.row[scope.column.property] / 100 }}
                </section>
                <!-- 运费 end -->
                <!-- 预付款 -->
                <section v-else-if="scope.column.property === 'preOilFee'">
                  {{ scope.row[scope.column.property] / 100 }}
                </section>
                <!-- 预付款 end -->
                <!-- 合同 -->
                <section v-else-if="scope.column.property === 'contractUrl'">
                  <template v-if="checkPermpisions('3300211')">
                    <span
                      class="primary cur"
                      @click="showContractDialog(scope.row)"
                      >{{ scope.row.loadState === 1 || scope.row.loadState === 4? '上传' : '查看' }}</span
                    >
                  </template>
                  <template v-else>
                    <span
                      v-if="scope.row.contractUrl"
                      class="primary cur"
                      @click="showContractDialog(scope.row)"
                      >查看</span
                    >
                  </template>
                </section>
                <!-- 合同 end -->
                <!-- 回单 -->
                <section v-else-if="scope.column.property === 'reciveTypeName'">
                  {{
                    scope.row.reciveTypeName
                      ? scope.row.reciveTypeName + '：'
                      : ''
                  }}
                  <template v-if="checkPermpisions('3300212')">
                    <span
                      class="primary cur"
                      @click="showBillDialog(scope.row)"
                      >{{
                        scope.row.reciveState === 1 ||
                        scope.row.reciveState === 4
                          ? '上传'
                          : '查看'
                      }}</span
                    >
                  </template>
                  <template v-else>
                    <span class="primary cur" @click="showBillDialog(scope.row)"
                      >查看</span
                    >
                  </template>
                </section>
                <!-- 回单 end -->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="100"
            fixed="right"
          >
            <template slot-scope="scope">
              <section>
                <qx-permpisions
                  permpisions="3300213"
                  v-if="
                    scope.row.preAmountFlag === 1 &&
                    scope.row.orderState > 10 &&
                    scope.row.isFinalAuditJurisdiction
                  "
                >
                  <span
                    class="primary cur"
                    @click="showApproveDialog(scope.row)"
                    >审核</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="showLog(scope.row.orderId)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import CarDetailDialog from 'components/carDetailDialog';
import LogRightDialog from 'components/logRightDialog';
import ContractDialog from '../contractDialog';
import BillDialog from '../billDialog/billDialog';
import ApproveDialog from './approveDialog';
import BatchApproveDialog from './batchApproveDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  orderReceiptList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    CarDetailDialog, // 车辆详情
    ContractDialog, // 合同
    BillDialog, // 单据
    ApproveDialog, // 单个审核
    BatchApproveDialog, // 批量审核
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'orderId',
        title: [ // 表头
          {
            prop: 'orderId',
            label: '订单号码',
            w: 180,
          },
          {
            prop: 'customName',
            label: '客户名称',
          },
          {
            prop: 'customNumber',
            label: '客户单号',
          },
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'sourceRegionName',
            label: '运输线路',
          },
          {
            prop: 'goodsName',
            label: '货品名称',
          },
          {
            prop: 'carLenghName',
            label: '车辆类型',
          },
          {
            prop: 'dependTime',
            label: '发车时间',
          },
          {
            prop: 'totalFee',
            label: '运费(元)',
          },
          {
            prop: 'preOilFee',
            label: '预付款(元)',
          },
          {
            prop: 'contractUrl',
            label: '合同',
            w: 80,
          },
          {
            prop: 'reciveTypeName',
            label: '回单',
            w: 180,
          },
          {
            prop: 'orderStateName',
            label: '回单状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderReceiptList,
    batchApprove () {
      if (this.tableData.selectResult.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      this.$refs.batchApproveDialog.show(this.tableData.selectResult);
    },
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
    toLineDetail (item) {
      if (item.sourceId === -1) {
        return;
      }
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.sourceId}`,
        full: true,
      });
    },
    showCarDetail (item) {
      this.$refs.carDetailDialog.show(item);
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    showContractDialog (item) {
      this.$refs.contractDialog.show(item);
    },
    showBillDialog (item) {
      this.$refs.billDialog.show(item);
    },
    showApproveDialog (item) {
      this.$refs.approveDialog.show(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
